import R from 'ramda';

import { createReducer } from 'ha/myredux/createReducer';
import { Actions } from '../constants';

export default createReducer(
  {
    [Actions.FETCH_FEATURE_FLAGS_SUCCESS]: (state, features) => ({
      ...state,
      ...features,
    }),
    [Actions.SET_FEATURES]: (state, features) => ({
      ...state,
      ...features,
    }),
  },
  {},
);

export const getFeatures = R.prop('features');
